'use client';

import Icon from '@/components/ui/AppIcon';

interface TrendingTopic {
  id: string;
  keyword: string;
  count: number;
  change: number;
}

interface PopularArticle {
  id: string;
  title: string;
  views: string;
}

export default function TrendingSidebar() {
  const trendingTopics: TrendingTopic[] = [
    { id: 'trend_topic_1', keyword: 'RBI Policy Decision', count: 2456, change: 234 },
    { id: 'trend_topic_2', keyword: 'IT Sector Rally', count: 1890, change: 156 },
    { id: 'trend_topic_3', keyword: 'Gold Price Surge', count: 1678, change: -89 },
    { id: 'trend_topic_4', keyword: 'IPO Listings', count: 1423, change: 98 },
    { id: 'trend_topic_5', keyword: 'Rupee Volatility', count: 1256, change: 67 },
  ];

  const popularArticles: PopularArticle[] = [
    {
      id: 'popular_1',
      title: 'Understanding the New RBI Guidelines for Digital Lending',
      views: '45.2K',
    },
    {
      id: 'popular_2',
      title: 'How Tech Stocks are Reshaping the Market Landscape',
      views: '38.7K',
    },
    {
      id: 'popular_3',
      title: 'Gold Investment Strategies for 2026',
      views: '32.4K',
    },
    {
      id: 'popular_4',
      title: 'Forex Trading Tips for Beginners',
      views: '28.9K',
    },
  ];

  return (
    <aside className="space-y-8">
      {/* Trending Topics */}
      <div className="bg-card border border-border rounded-xl p-6">
        <h3 className="text-xl font-bold text-foreground mb-6 flex items-center gap-2">
          <Icon name="FireIcon" size={24} className="text-accent" variant="solid" />
          Trending Topics
        </h3>
        <div className="space-y-4">
          {trendingTopics.map((topic, index) => (
            <div key={topic.id} className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <span className="text-2xl font-bold text-muted-foreground/30 font-mono">
                  {(index + 1).toString().padStart(2, '0')}
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground">
                    {topic.keyword}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {topic.count.toLocaleString()} mentions
                  </p>
                </div>
              </div>
              <div
                className={`flex items-center gap-1 text-xs font-mono ${
                  topic.change >= 0 ? 'text-primary' : 'text-secondary'
                }`}
              >
                <Icon
                  name={topic.change >= 0 ? 'ArrowUpIcon' : 'ArrowDownIcon'}
                  size={14}
                  variant="solid"
                />
                {Math.abs(topic.change)}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Most Read */}
      <div className="bg-card border border-border rounded-xl p-6">
        <h3 className="text-xl font-bold text-foreground mb-6 flex items-center gap-2">
          <Icon name="EyeIcon" size={24} className="text-primary" />
          Most Read
        </h3>
        <div className="space-y-4">
          {popularArticles.map((article, index) => (
            <div key={article.id} className="group cursor-pointer">
              <div className="flex gap-3">
                <span className="text-xl font-bold text-muted-foreground/30 font-mono">
                  {(index + 1).toString().padStart(2, '0')}
                </span>
                <div className="flex-1">
                  <p className="text-sm font-semibold text-foreground group-hover:text-primary transition-colors line-clamp-2 mb-2">
                    {article.title}
                  </p>
                  <p className="text-xs text-muted-foreground flex items-center gap-1">
                    <Icon name="EyeIcon" size={12} />
                    {article.views} views
                  </p>
                </div>
              </div>
              {index < popularArticles.length - 1 && (
                <div className="mt-4 border-b border-border" />
              )}
            </div>
          ))}
        </div>
      </div>
    </aside>
  );
}